import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import { ProductContextService } from 'src/Foundation/Design/app';
import { getContactSupportUrl } from 'src/Foundation/Design/app';
import { spotName } from '../constants/spot-name';
import template from './btpg-wtu.component.html';
var BtpgWtuComponent = (function () {
    function BtpgWtuComponent(productContextService) {
        this.productContextService = productContextService;
        this.stepId = '';
        this.stepName = '';
        this.platformLabel = '';
        this.platformName = '';
    }
    BtpgWtuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) { _this.contactSupportUrl = getContactSupportUrl(group); });
    };
    Object.defineProperty(BtpgWtuComponent.prototype, "wtuItemLink", {
        get: function () {
            return spotName + "/" + this.platformName + "/" + this.stepName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BtpgWtuComponent.prototype, "visible", {
        get: function () {
            return Boolean(this.platformLabel && this.stepId && this.stepName);
        },
        enumerable: false,
        configurable: true
    });
    BtpgWtuComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgWtuComponent.prototype, "stepId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgWtuComponent.prototype, "stepName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgWtuComponent.prototype, "platformLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgWtuComponent.prototype, "platformName", void 0);
    BtpgWtuComponent = __decorate([
        Component({
            selector: 'btpgWtu',
            template: template,
        }),
        __param(0, Inject('productContextService')),
        __metadata("design:paramtypes", [ProductContextService])
    ], BtpgWtuComponent);
    return BtpgWtuComponent;
}());
export { BtpgWtuComponent };
